import { createFileRoute } from '@tanstack/react-router'
import { MinigamesLayout } from '@/features/minigames/components'

export const Route = createFileRoute('/_authenticated/minigames')({
  component: MinigamesLayout,
})
